import React from "react";

function IconArrowDropdown(props) {
  return (
    <div className={props.className} >
        <svg
          style={{
            margin: props.marg,
            transform: props.transform,
            transition: props.transition
          }}
          height={props.height}
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          strokeLinejoin="round"
          strokeMiterlimit="2"
          clipRule="evenodd"
          viewBox="0 0 270 158"
        >
        <path
            className={props.pathClass ? props.pathClass : "g1-fill"}
            d="M246.63 3.536a5 5 0 017.071 0L270.2 20.035a5 5 0 010 7.071L138.793 158.513a5.002 5.002 0 01-1.791 1.15l-.134.047a5 5 0 01-1.926-1.197L3.536 27.106a5.001 5.001 0 010-7.071L20.035 3.536a5 5 0 017.071 0l109.762 109.762L246.63 3.536z"
            transform="translate(-2.071 -2.071)"
            
        ></path>
        </svg>
    </div>
  );
}

export default IconArrowDropdown;
